import React from 'react'
import {
  fetchChatCommunitySummary,
  type ChatCommunitySummaryMap,
} from '../services/chatCommunityService'

export function useChatCommunitySummary(chatIds: number[], enabled: boolean) {
  const [map, setMap] = React.useState<ChatCommunitySummaryMap | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const ids = React.useMemo(
    () =>
      Array.from(
        new Set(
          (chatIds || [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id)),
        ),
      ),
    [chatIds],
  )

  React.useEffect(() => {
    if (!enabled || ids.length === 0) {
      setMap(null)
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    fetchChatCommunitySummary(ids)
      .then((data) => {
        if (!active) return
        setMap(data)
      })
      .catch((e: any) => {
        if (!active) return
        setMap(null)
        setError(e?.message || 'Falha ao carregar comunidade do chat')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, ids])

  return { map, loading, error }
}
